export const flattenObject = (obj, target = {}, path = []) => {
  if (!target) {
    target = {};
  }
  if (!path) {
    path = [];
  }
  if (obj && (typeof obj === 'object')) {
    Object.entries(obj).forEach(entry => flattenObject(entry[1], target, path.concat([ entry[0] ])));
  } else {
    target[path.join('.')] = obj;
  }
  return target;
};
